import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <div class="tablet-message">
            <p>This website is best viewed on Mobile (Potrait) and laptop.</p>
        </div>
        <App />
    </BrowserRouter>
);
